import React from 'react';

import TireChangeStore from '../tire-change-store';

class Login extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        if (window.is_user_logged_in) {
            return (
                <section className="login">
                    <div className="infobox">
                        <h4><i className="fa fa-exclamation-circle"></i><b>Oletko rengashotellimme asiakas?</b><br/></h4>
                        <p>Rengashotellin ajanvaraukset pääset hoitamaan alta tai sähköpostissa lähettämästämme linkistä.</p>
                        <br/>
                        <p><a className="btn" href="/hotellihistoria/">Siirry rengashotelliin</a></p>
                    </div>
                </section>
            );
        }
        return (
            <section className="login">
                <div className="infobox">
                    <h4><i className="fa fa-exclamation-circle"></i><b>Löytyykö sinulta jo käyttäjätunnus Nettivanteeseen tai oletko rengashotellimme asiakas?</b><br/></h4>
                    <p>Jos olet asioinut Rengas Turun toimipisteissä niin tietosi todennäköisesti löytyvät jo järjestelmästämme.</p>
                    <p>Kirjautumalla sisään ennen ajanvarausta täytämme yhteystietosi valmiiksi.</p>
                    <p><a className="btn" href="/kirjautuminen/?next=/ajanvaraus-allelaitto/">Kirjaudu sisään tästä</a></p>
                    <br/>
                    <p>Rengashotellin ajanvaraukset pääset hoitamaan alta tai sähköpostissa lähettämästämme linkistä.</p>
                    <p><a className="btn" href="/kirjautuminen/?next=/hotellihistoria/">Kirjaudu rengashotelliin</a></p>
                </div>
            </section>
        );
    }
}

<div className="box">
<p><strong> Oletko rengashotelliasiakkaamme?</strong><br/><br/></p>
</div>

export default Login;


/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/tire-change/components/Login.js
 **/